"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAriaDescribedByIds = void 0;

var _constants = require("../../constants");

var getAriaDescribedByIds = function getAriaDescribedByIds(formElementId, helpText, stateText, subText) {
  var ariaDescribedByIds = [];

  var getAriaDescribedByForSection = function getAriaDescribedByForSection(key, value) {
    if (Array.isArray(value) && value.length !== 1) {
      value.forEach(function (text, index) {
        return ariaDescribedByIds.push("".concat(formElementId, "-").concat(key, "-").concat(index));
      });
    } else ariaDescribedByIds.push("".concat(formElementId, "-").concat(key));
  };

  if (subText) getAriaDescribedByForSection(_constants.SUB_TEXT, subText);
  if (helpText) getAriaDescribedByForSection(_constants.HELP_TEXT, helpText);
  if (stateText) getAriaDescribedByForSection(_constants.STATE_TEXT, stateText);
  return ariaDescribedByIds.join(' ');
};

exports.getAriaDescribedByIds = getAriaDescribedByIds;
//# sourceMappingURL=index.js.map